import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';

import { NotificationType } from '@enums';
import * as CoreActions from '@state';
import * as PayRollActions from '@state/pay-roll';
import * as UserActions from '@state/user';
import * as VehicleActions from '@state/vehicle/vehicle.actions';
import { FcmService } from './services/fcm/fcm.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(private store: Store, private fcmService: FcmService) {
    store.dispatch(CoreActions.appInit());
    this.fcmService.init();
    this.fcmService.getMessages().subscribe((msg) => {
      if (msg) {
        console.log('New message received:', msg);
        if (msg?.data?.type === NotificationType.PayRollBatch) {
          this.store.dispatch(PayRollActions.fetchPayRollBatches());
        }
        if (msg?.data?.type === NotificationType.UserBatch) {
          this.store.dispatch(UserActions.fetchBatches());
        }
        if (msg?.data?.type === NotificationType.VehicleBatch) {
          this.store.dispatch(VehicleActions.fetchVehicleBatches());
        }
      }
    });
  }
}
